import React from 'react';
import { Button, Typography } from 'antd';
import { CloseOutlined, EditOutlined } from '@ant-design/icons';
import { Message } from '../../types/chat';
import './EditField.css';
import { getOriginalMessageText } from './utils';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

interface EditFieldProps {
  editingMessage: Message;
  onCancelEdit: () => void;
}

const EditField: React.FC<EditFieldProps> = ({ editingMessage, onCancelEdit }) => {

  const originalText = getOriginalMessageText(editingMessage);
  const truncatedText = originalText.length > 50 ? originalText.substring(0, 50) + '...' : originalText;
  const { t } = useTranslation();

  return (
    <div className="edit-field">
      <div className="edit-field-content">
        <div className="edit-field-icon">
          <EditOutlined style={{ color: '#1677ff' }} />
        </div>
        <div className="edit-field-text">
          <div className="edit-field-label">
            <Text type="secondary" style={{ fontSize: '12px' }}>
              {t('chat.editingMessage')}
            </Text>
          </div>
          <div className="edit-field-message">
            <Text style={{ fontSize: '13px', marginLeft: '8px' }}>
              {truncatedText}
            </Text>
          </div>
        </div>
      </div>
      <Button
        type="text"
        size="small"
        icon={<CloseOutlined />}
        onClick={onCancelEdit}
        style={{ color: '#999' }}
      />
    </div>
  );
};

export default EditField; 